"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CreatorProductType;
(function (CreatorProductType) {
    CreatorProductType[CreatorProductType["Behaviour"] = 0] = "Behaviour";
    CreatorProductType[CreatorProductType["Process"] = 1] = "Process";
    CreatorProductType[CreatorProductType["Skills"] = 2] = "Skills";
})(CreatorProductType = exports.CreatorProductType || (exports.CreatorProductType = {}));
var CreatorLanguage;
(function (CreatorLanguage) {
    CreatorLanguage["NORWEGIAN"] = "norwegian";
    CreatorLanguage["ENGLISH"] = "english";
    CreatorLanguage["DANISH"] = "danish";
    CreatorLanguage["SWEDISH"] = "swedish";
    CreatorLanguage["CZECH"] = "czech";
    CreatorLanguage["SPANISH"] = "spanish";
    CreatorLanguage["CHINESE"] = "chinese";
    CreatorLanguage["PORTUGESE"] = "portuguese";
    CreatorLanguage["GERMAN"] = "german";
    CreatorLanguage["KOREAN"] = "korean";
    CreatorLanguage["FRENCH"] = "french";
    CreatorLanguage["RUSSIAN"] = "russian";
    CreatorLanguage["JAPANESE"] = "japanese";
    CreatorLanguage["FINNISH"] = "finnish";
    CreatorLanguage["LITHUANIAN"] = "lithuanian";
    CreatorLanguage["TURKISH"] = "turkish";
    CreatorLanguage["HUNGARIAN"] = "hungarian";
    CreatorLanguage["ITALIAN"] = "italian";
    CreatorLanguage["GREEK"] = "greek";
})(CreatorLanguage = exports.CreatorLanguage || (exports.CreatorLanguage = {}));
//# sourceMappingURL=creatorEnums.js.map